import {
  DisciplineEvaluationDeliverable,
  DisciplineExercisesDeadline,
} from '@/models/evaluation-and-deadlines/evaluation-and-deadlines.model';
import { UndergradDiscipline } from '@/models/undergrad/undergrad-discipline.model';
import { UserMicrocertificate } from '@/store/modules/microcertificates/types';
import { ListModel } from '@descomplica/dex-models';

export interface GradeWorthyActivitieDiscipline extends UndergradDiscipline {
  reviewLists?: ListModel[];
  exercisesDeadlines?: DisciplineExercisesDeadline;
  activities?: DisciplineEvaluationDeliverable[];
  grade?: number;
}

export interface GradeWorthyActivities {
  microcertificate: UserMicrocertificate;
  disciplines: GradeWorthyActivitieDiscipline[];
}

export interface GradeWorthyActivitiesState {
  gradeWorhtyActivities?: GradeWorthyActivities[];
}

const state: GradeWorthyActivitiesState = {
  gradeWorhtyActivities: undefined,
};

export default state;
